import * as Website from '../Config/Website.js';

// タブフィルタリング機能
const init = () => {
  const tabs = document.querySelectorAll('.js-tab');
  const items = document.querySelectorAll('.js-tabItem');
  if (tabs.length === 0 || items.length === 0) return;

  // 2列グリッドの市松模様になるよう、表示中アイテムへ配色クラスを振り直す
  const applyTones = () => {
    let visibleIndex = 0;
    items.forEach((item) => {
      if (item.classList.contains(Website.classList.hidden)) return;
      const isToneA = (Math.floor(visibleIndex / 2) + (visibleIndex % 2)) % 2 === 0;
      item.classList.toggle('--a', isToneA);
      item.classList.toggle('--b', !isToneA);
      visibleIndex += 1;
    });
  };

  const filterItems = (activeTab) => {
    items.forEach((item) => {
      const show = activeTab === 'all' || item.dataset.category === activeTab;
      item.classList.toggle(Website.classList.hidden, !show);
    });
    applyTones();
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove(Website.classList.act));
      tab.classList.add(Website.classList.act);
      filterItems(tab.dataset.tab);
    });
  });
};

export default init;
